
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 4)"}},[_c('path',{attrs:{"d":"M1 11l-.906-.423a1 1 0 000 .846L1 11zm28 0l.906.423a1 1 0 000-.846L29 11zm-14 9c-4.282 0-7.536-2.29-9.769-4.682a21.56 21.56 0 01-2.507-3.284 18.757 18.757 0 01-.774-1.367 8.505 8.505 0 01-.035-.072l-.008-.016a.026.026 0 01-.001-.003L1 11l-.906.424.002.003a.493.493 0 00.017.036l.046.095a20.824 20.824 0 00.866 1.533 23.569 23.569 0 002.744 3.591C6.203 19.29 9.949 22 15 22v-2zM1 11l.906.424.001-.003.008-.016a8.505 8.505 0 01.186-.364c.137-.256.344-.627.623-1.075a21.56 21.56 0 012.507-3.284C7.464 4.29 10.718 2 15 2V0C9.948 0 6.203 2.71 3.769 5.318a23.569 23.569 0 00-2.743 3.591 20.824 20.824 0 00-.867 1.533 8.427 8.427 0 00-.064.133v.001c-.001 0-.001.001.905.424zm14-9c4.282 0 7.536 2.29 9.769 4.682a21.56 21.56 0 012.507 3.284 18.757 18.757 0 01.774 1.367l.035.072.008.016.001.003L29 11l.906-.424-.002-.003a.392.392 0 00-.017-.036 13.537 13.537 0 00-.224-.438c-.154-.29-.384-.7-.689-1.19a23.569 23.569 0 00-2.743-3.591C23.797 2.71 20.051 0 15 0v2zm14 9l-.906-.424-.001.003-.008.016a8.505 8.505 0 01-.186.364c-.137.256-.344.627-.623 1.075a21.56 21.56 0 01-2.507 3.284C22.536 17.71 19.282 20 15 20v2c5.051 0 8.797-2.71 11.231-5.318a23.569 23.569 0 002.743-3.591 20.787 20.787 0 00.866-1.533 7.877 7.877 0 00.065-.133v-.001c.001 0 .001-.001-.905-.424z"}}),_c('circle',{attrs:{"fill":"none","stroke-width":"2","cx":"15","cy":"11","r":"4"}})])])
          )
        }
      }
    